// src/libs/datadog.js

import { datadogRum } from '@datadog/browser-rum'

export const initializeDatadog = (env) => {
    datadogRum.init({
        applicationId: '82558314-1526-4be7-ba7f-1a1029fe86fc',
        clientToken: 'pub9c8fd7c5e551c0b64cc81b80c746574c',
        site: 'datadoghq.com',
        service: 'deepblok---kbankwpp---lineliff',
        env: env, // Set dynamically
        sessionSampleRate: 10,
        sessionReplaySampleRate: 0,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
    });


    
};
